import React, { useState, useEffect, useRef } from "react";
import { getRequest, postRequest } from "../../apiWrapper";
import Modal from "react-modal";
import { FaEnvelopeOpenText, FaCheckCircle } from "react-icons/fa";

Modal.setAppElement("#root");

const TeacherNotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const data = await getRequest("notifications/list?includeRead=true");
        setNotifications(data);
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    })();
  }, []);

  const markAsRead = async (id) => {
    try {
      await postRequest("notifications/read", { notification_id: id });
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, read: true } : n))
      );

      window.dispatchEvent(new Event("notificationRead"));
    } catch (err) {
      console.error("Error marking as read:", err);
    }
  };

  const openModal = (notification) => {
    setSelected(notification);
    setModalOpen(true);
  };

  const handleMarkRead = () => {
    if (selected && !selected.read) {
      markAsRead(selected.id);
    }
    handleClose();
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelected(null);
  };

  return (
    <div className="p-6 pt-20 bg-gradient-to-br to-blue-50 min-h-screen">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">お知らせ</h1>
      <div className="grid gap-4">
        {notifications.map((n) => (
          <div
            key={n.id}
            onClick={() => openModal(n)}
            className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transform hover:-translate-y-1 transition cursor-pointer flex justify-between items-center"
          >
            <div>
              <h2 className="text-xl font-semibold text-gray-700">{n.title}</h2>
              <p className="text-sm text-gray-500">
                {new Date(n.published_at).toLocaleDateString()}
              </p>
            </div>
            <div>
              {n.read ? (
                <FaCheckCircle className="text-green-500 text-2xl" />
              ) : (
                <FaEnvelopeOpenText className="text-blue-500 text-2xl animate-bounce" />
              )}
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={modalOpen}
        onRequestClose={handleClose}
        className="bg-white p-6 rounded-2xl shadow-2xl max-w-2xl mx-auto my-20 outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center"
      >
        <h2 className="text-2xl font-bold mb-4">{selected?.title}</h2>
        <div className="max-h-80 overflow-y-auto pr-2 mb-6">
          <p className="text-gray-700 whitespace-pre-wrap">{selected?.message}</p>
        </div>
        <div className="flex justify-end gap-4">
          {!selected?.read && (
            <button
              onClick={handleMarkRead}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
            >
              既読にする
            </button>
          )}
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition"
          >
            閉じる
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default TeacherNotificationsPage;
